export default __webpack_public_path__ + "static/media/bootstrap.1f1d6bd3.svg";